import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { applyBufferData } from '../../actions/buffer';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$locationId',
  initialState,
  reducers: {
    setLocationId(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetOrder, (state, action) => {
        return initialState;
      })
      .addCase(applyBufferData, (state, action) => {
        const { locationId } = action.payload;
        return locationId === undefined ? state : locationId;
      });
  },
});

export const { setLocationId } = slice.actions;
export default slice.reducer;
